import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { defaults } from 'lodash';

import { useTheme } from '../../context';
import { ComponentPropsWithRef } from '../../types/utils';
import { ButtonOwnProps } from './button.model';
import { getButtonClassName } from './button.util';
import { ButtonBody } from './button-body.component';

export type ButtonProps = ComponentPropsWithRef<'button'> & ButtonOwnProps;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  function Button(
    {
      type = 'button',
      className,
      disabled: isDisabled,
      active,
      children,
      variant,
      leftIcon,
      rightIcon,
      size,
      isPending,
      pendingText,
      onlyIcon,
      ...rest
    },
    ref
  ) {
    const { button } = useTheme();
    const disabled = isDisabled || isPending;
    const hasIcon = Boolean(leftIcon || rightIcon || isPending);

    return (
      <button
        ref={ref}
        type={type}
        disabled={disabled}
        className={classNames(
          getButtonClassName(
            defaults(
              {
                variant,
                disabled,
                active,
                size,
              },
              button
            ),
            {
              hasIcon,
              onlyIcon: onlyIcon || Boolean(isPending && !pendingText),
            }
          ),
          className
        )}
        {...rest}
      >
        <ButtonBody
          leftIcon={leftIcon}
          rightIcon={rightIcon}
          variant={variant}
          isPending={isPending}
          pendingText={pendingText}
        >
          {children}
        </ButtonBody>
      </button>
    );
  }
);
